<template>
    <div>
        <el-table
            :data="tableData"
            :max-height="200"
            border
            @header-dragend="headerDragendHandler"
        >
            <el-table-column
                show-overflow-tooltip
                v-for="(item, index) in columnsList"
                :key="index"
                :prop="item.prop"
                :label="item.label"
                :width="item.width"
            >
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
export default {
    props: {
        contentTableData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            tableData: [],
            columnsList: [
                {
                    label: '客户订单号',
                    prop: 'customerOrderNo',
                    width: '220'
                },
                {
                    label: '商品分类',
                    prop: 'itemClassNameListString',
                    width: '180'
                },
                {
                    label: '方数(m³)',
                    prop: 'totalVolume',
                    width: '120'
                },
                {
                    label: '计划数量',
                    prop: 'totalQty',
                    width: '120'
                },
                {
                    label: '收货单位',
                    prop: 'upperReceiverName',
                    width: '160'
                },
                {
                    label: '目的区县',
                    prop: 'receiverDistrictName',
                    width: '90'
                },
                {
                    label: '目的乡镇',
                    prop: 'receiverTownName',
                    width: '100'
                },
                {
                    label: '详细地址',
                    prop: 'receiverDetailAddr',
                    width: '180'
                },
                {
                    label: '要求发车时间',
                    prop: 'requireDepartTime',
                    width: '160'
                },
                {
                    label: '装货仓库',
                    prop: 'whName',
                    width: '100'
                },
                {
                    label: '是否限行',
                    prop: 'restrictFlagName',
                    width: '80'
                },

                {
                    label: '收货人',
                    prop: 'receiverName',
                    width: '80'
                },
                {
                    label: '收货人联系方式',
                    prop: 'receiverMobile',
                    width: '120'
                },
                {
                    label: '服务平台',
                    prop: 'siteName',
                    width: '120'
                }

            ]
        };
    },
    created () {
        this.tableData = [].concat(this.contentTableData.lineOrderResponseList);
    },
    methods: {
        headerDragendHandler (newWidth, oldWidth, column, event) {
        }
    }
};
</script>
<style lang="less">
</style>
